import { FisrtChageState, initState } from './initState'
import {
  OpenModalParams,
  proxyOpenWaitingGetModal
} from './proxyOpenWaitingGetModal'
import { apiGetPopWaitingGetReward } from '../api/apiGetPopWaitingGetReward/index'
import { defineStore } from 'pinia'
import { userRecord } from './initState/userOpeningWaitingGetRecord'

/** 待领取奖励的store */
export type WaitingGetStore = ReturnType<typeof useWaitingGetStore>

/** 待领取奖励的store */
export const useWaitingGetStore = defineStore('waitingGetStore', {
  state: () => initState() as FisrtChageState,
  getters: {},
  actions: {
    /** 刷新弹窗数据 */
    async freshPopData() {
      const resPopWeb = await apiGetPopWaitingGetReward()
      FisrtChageState.immitPopWaitingGetWeb(this, resPopWeb)
    },
    /** 切换显示弹窗的状态 */
    switchPopAppearStatus(name: 'isNeverRemind' | 'isThisTimeNoRemind') {
      this[name] = !this[name]
      userRecord.recordUserCheckDayOpen(this[name])
    },
    /** 打开弹窗 */
    async openWaitingGetModal(
      params?: Partial<Omit<OpenModalParams, 'store'>>
    ) {
      const { isLoginTrigger = false, isFreshData = true } = params || {}
      await proxyOpenWaitingGetModal({
        store: this,
        isLoginTrigger,
        isFreshData
      })
    },
    /** 记录用户打开过弹窗的行为 */
    recordUserOpeningRecord() {
      this.isHaveOpenedToday = true
      this.isHaveOpenedEver = true
      userRecord.recordUserOpeningRecord()
    },
    /** 重置 */
    myReset() {
      FisrtChageState.resetState(this)
    }
  }
})
